import { combineReducers, createSlice } from '@reduxjs/toolkit'

import seatingReducer from './components/HallSeating/reducer'

const hallSlice = createSlice({
    name: 'hall',
    initialState: {
        urlParamsOk: true,
        modalWarning: null,
        loading: false,
        disable: false,
        data: null,
        seatsInfoData: null,
        hallInfoData: null,
        selectedSeats: [],
    },
    reducers: {
        setLoading(state, action) {
            const { payload } = action

            state.loading = payload
        },
        setDisableHall(state, action) {
            const { payload } = action

            state.disable = payload
        },
        setUrlParamsOk(state, action) {
            const { payload } = action
            state.urlParamsOk = payload
        },
        setError(state, action) {
            const { payload } = action

            if (!payload) {
                return { ...state, error: null }
            }

            return { ...state, error: payload }
        },
        getHallInfoData() {
            //gqlQuery
        },
        setHallInfoData(state, action) {
            const { payload } = action
            state.seatsInfoData = payload.seats
            state.hallInfoData = payload.hall
        },
        setModalWarning(state, action) {
            const { payload } = action

            if (!payload) {
                return { ...state, modalWarning: null }
            }

            return { ...state, modalWarning: payload }
        },
        loadData() {},
        releaseBasketAndLoadHall() {},
        setData(state, action) {
            const { payload } = action

            if (!payload) {
                return state
            }

            return { ...state, data: payload }
        },
        handleSeatClick() {},
        seatSelected(state, action) {
            const { payload } = action

            if (!payload) {
                return state
            }

            return { ...state, selectedSeats: [...state.selectedSeats, payload] }
        },
        seatUnselected(state, action) {
            const { payload } = action

            if (!payload) {
                return state
            }

            return { ...state, selectedSeats: state.selectedSeats.filter((seat) => seat?.seatid !== payload?.seatid) }
        },
        setSelectedSeats(state, action) {
            const { payload } = action

            return { ...state, selectedSeats: payload }
        },
        handleBasketConfirm() {},
    },
})

const { actions, reducer } = hallSlice

export const {
    setLoading,
    setError,
    setWarning,
    loadData,
    setData,
    handleSeatClick,
    seatSelected,
    seatUnselected,
    setSelectedSeats,
    handleBasketConfirm,
    setDisableHall,
    setUrlParamsOk,
    setModalWarning,
    releaseBasketAndLoadHall,
    getHallInfoData,
    setHallInfoData,
} = actions

export default combineReducers({
    movie: reducer,
    seating: seatingReducer,
})
